export const FETCH_TRANSLATION_REQUEST = 'translations/FETCH_TRANSLATION_REQUEST';
export const FETCH_TRANSLATION_SUCCESS = 'translations/FETCH_TRANSLATION_SUCCESS';
export const FETCH_TRANSLATION_FAILURE = 'translations/FETCH_TRANSLATION_FAILURE';

export const RESOLUTION_CHANGE = 'translations/RESOLUTION_CHANGE';